import React from "react";
import { useQuery } from "@tanstack/react-query";
import { EmailTemplatePreview } from "@truevault/aquilo";
import { Api } from "../../../common/service/Api";
import { OrganizationPublicId } from "../../../common/service/server/Types";
import { VendorRequestCustomFieldSettings } from "../../components/organisms/settings/rows/VendorRequestCustomFieldSettings";

export type VendorFlowDownEmailType = "delete" | "opt-out" | "limit";
const subjects: Record<VendorFlowDownEmailType, string> = {
  delete: "CCPA Request to Delete",
  "opt-out": "Request to Opt-Out",
  limit: "CCPA Request to Limit",
};

export function VendorFlowDownEmailPreview({
  organizationId,
  requestType,
}: {
  organizationId: OrganizationPublicId;
  requestType: VendorFlowDownEmailType;
}) {
  const { data, isError, refetch } = useQuery({
    queryKey: ["vendorMessageTemplatePreview", organizationId, requestType],
    queryFn: () =>
      Api.dataRequest.getRequestContactVendorsPreviewMessageTemplateForRequestType(
        organizationId,
        requestType,
      ),
    enabled: !!organizationId,
    // Never display a different organization's or workflow's previous preview during navigation.
    keepPreviousData: false,
  });

  return (
    <EmailTemplatePreview
      title="Vendor Email Notification Template"
      recipient="vendor@example.com"
      subject={subjects[requestType]}
      html={data}
      error={isError ? "Couldn’t refresh this preview. Retry to see the current email." : undefined}
      onRetry={() => {
        void refetch();
      }}
    >
      <VendorRequestCustomFieldSettings
        organizationId={organizationId}
        source={
          requestType === "delete"
            ? "REQUEST_FORM"
            : requestType === "limit"
            ? "LIMIT"
            : "OPT_OUT_FORM"
        }
      />
    </EmailTemplatePreview>
  );
}
